/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyKip = createReactComponent("outline", "currency-kip", "IconCurrencyKip", [["path", { "d": "M6 12h12", "key": "svg-0" }], ["path", { "d": "M9 5v14", "key": "svg-1" }], ["path", { "d": "M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7", "key": "svg-2" }]]);

export { IconCurrencyKip as default };
//# sourceMappingURL=IconCurrencyKip.mjs.map
